
import { ContentCard } from "../content-card";
import { ContentItem } from "../content-card/types";
import ListItemCard from "../content-card/ListItemCard";

interface ContentListProps {
  contentItems: ContentItem[];
  onContentClick: (id: string) => void;
  onDeleteContent: (id: string) => void;
  onEditContent?: (id: string, currentTitle: string) => void;
  onArchiveContent?: (id: string) => void;
  onPin?: (id: string) => void;
  onUnpin?: (id: string) => void;
  collectionColor?: string | null;
  allContentIds: string[];
}

const ContentList = ({ 
  contentItems, 
  onContentClick, 
  onDeleteContent, 
  onEditContent,
  onArchiveContent,
  onPin,
  onUnpin,
  collectionColor,
  allContentIds
}: ContentListProps) => {
  console.log('[COLOR DEBUG] ContentList rendering with:', {
    itemsCount: contentItems.length,
    collectionColor,
    firstItemColor: contentItems[0]?.collection_color
  });

  // Debug pinned items in list
  const pinnedItems = contentItems.filter(item => item.pinned);
  console.log(`[PIN DEBUG] ContentList - Total items: ${contentItems.length}, Pinned items: ${pinnedItems.length}`);
  contentItems.forEach(item => {
    console.log(`[PIN DEBUG] ContentList - Item ${item.id} (${item.title}) pinned: ${item.pinned}`);
  });

  if (contentItems.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg border border-dashed border-gray-300">
        <p className="text-gray-500">No content items available</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {contentItems.map((item) => {
        console.log(`[COLOR DEBUG] ContentList - Item ${item.id} color: ${item.collection_color || 'none'}, using: ${item.collection_color || collectionColor || "#6B7789"}`);
        console.log(`[PIN DEBUG] ContentList - Rendering item ${item.id} with pinned: ${item.pinned}`);
        
        const handleCardClick = () => {
          console.log(`[NAVIGATION DEBUG] ContentList - Card clicked: ${item.id} (${item.title})`);
          onContentClick(item.id);
        };

        return (
          <div key={item.id} className="w-full">
            <ListItemCard
              item={item}
              onClick={handleCardClick}
              onDelete={onDeleteContent}
              onEdit={onEditContent}
              onArchive={onArchiveContent}
              onPin={onPin}
              onUnpin={onUnpin}
              allContentIds={allContentIds}
              selectable={true}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ContentList;
